import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { CandidateStage } from '../../types';
import { CANDIDATE_STAGE_COLORS, CANDIDATE_STAGES } from '../../data/mockCandidates';

interface CandidateStatusBadgeProps {
  currentStatus: CandidateStage;
  onStatusChange: (newStatus: CandidateStage) => void;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'px-2 py-1 text-xs',
  md: 'px-3 py-1 text-sm',
  lg: 'px-4 py-2 text-base'
};

export const CandidateStatusBadge: React.FC<CandidateStatusBadgeProps> = ({
  currentStatus,
  onStatusChange,
  disabled = false,
  size = 'md',
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  
  const statusStyle = CANDIDATE_STAGE_COLORS[currentStatus];
  
  if (disabled) {
    return (
      <span 
        className={`
          inline-flex items-center ${sizeClasses[size]} font-medium rounded-full border 
          ${statusStyle.bg} ${statusStyle.text} ${statusStyle.border}
          ${className}
        `}
      >
        {currentStatus}
      </span>
    );
  }

  return (
    <div className={`relative ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`
          inline-flex items-center ${sizeClasses[size]} font-medium rounded-full border 
          ${statusStyle.bg} ${statusStyle.text} ${statusStyle.border}
          hover:opacity-80 transition-opacity cursor-pointer gap-1
        `}
      >
        {currentStatus}
        <ChevronDown className="w-3 h-3" />
      </button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute top-full left-0 mt-1 w-40 bg-white border border-gray-200 rounded-md shadow-lg z-20">
            {CANDIDATE_STAGES.map((stage) => {
              const stageStyle = CANDIDATE_STAGE_COLORS[stage];
              return (
                <button
                  key={stage}
                  onClick={() => {
                    onStatusChange(stage);
                    setIsOpen(false);
                  }}
                  className={`
                    w-full text-left px-3 py-2 text-sm hover:bg-gray-50 flex items-center gap-2 transition-colors
                    ${stage === currentStatus ? 'bg-gray-50' : ''}
                  `}
                >
                  <span 
                    className={`
                      w-3 h-3 rounded-full border
                      ${stageStyle.bg} ${stageStyle.border}
                    `} 
                  />
                  {stage}
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default CandidateStatusBadge;